import { Link } from "react-router-dom";
import { MDBRow, MDBCol, MDBCard, MDBIcon, MDBBtn } from "mdbreact";

import ROUTES from "Constants/routes.constants";
import locale from "locale";

const HomeActions = () => {
  return (
    <section className="text-center">
      <MDBRow className="moz-p-home-actions">
        <MDBCol md="12" className="mb-4">
          <MDBCard className="card-image moz-p-home-actions__item moz-p-home-actions__item--1">
            <div className="text-white text-center d-flex flex-column align-items-center rgba-black-light py-5 px-4 rounded">
              <h6 className="text-primary">
                <Link
                  className="moz-p-home-actions__item-icon moz-p-home-actions__item-icon--1"
                  to={ROUTES.COMMON.SUMMER_VACATION}
                >
                  <MDBIcon icon="umbrella-beach" />
                  <strong>{locale.TRAVELS.SUMMER_VACATION}</strong>
                </Link>
              </h6>
              <h3 className="py-3 font-weight-bold text-shadow heading-tertiary">
                <Link to={ROUTES.COMMON.SUMMER_VACATION}>
                  <strong className="text-white">
                    {locale.TRAVELS.SUMMER_YEAR}
                  </strong>
                </Link>
              </h3>
              <p className="pb-4 text-shadow paragraph">
                {locale.TRAVELS.SUMMER_DESCRIPTION_PART_1}
                <br />
                {locale.TRAVELS.SUMMER_DESCRIPTION_PART_2}
              </p>
              <Link to={ROUTES.COMMON.SUMMER_VACATION}>
                <MDBBtn color="primary" rounded size="md">
                  <MDBIcon far icon="clone" className="left" />
                  {locale.COMMON.LOOK}
                </MDBBtn>
              </Link>
            </div>
          </MDBCard>
        </MDBCol>
        <MDBCol md="6" className="md-0 mb-4">
          <MDBCard className="card-image moz-p-home-actions__item moz-p-home-actions__item--2">
            <div className="text-white text-center  d-flex align-items-center rgba-black-light py-5 px-4 rounded">
              <div>
                <h6>
                  <Link
                    className="pink-text moz-p-home-actions__item-icon"
                    to={ROUTES.COMMON.EUROPEAN_CITIES}
                  >
                    <MDBIcon icon="archway" />
                    <strong>{locale.TRAVELS.EUROPE}</strong>
                  </Link>
                </h6>

                <h3 className="py-3 font-weight-bold text-shadow heading-tertiary">
                  <Link to={ROUTES.COMMON.EUROPEAN_CITIES}>
                    <strong className="text-white">
                      {locale.TRAVELS.EUROPEAN_CITIES}
                    </strong>
                  </Link>
                </h3>
                <p className="pb-4 text-shadow paragraph">
                  {locale.TRAVELS.EUROPE_DESCRIPTION_PART_1}
                  <br />
                  {locale.TRAVELS.EUROPE_DESCRIPTION_PART_2}
                </p>
                <Link to={ROUTES.COMMON.EUROPEAN_CITIES}>
                  <MDBBtn color="unique" rounded size="md">
                    <MDBIcon far icon="clone" className="left" />
                    {locale.COMMON.LOOK}
                  </MDBBtn>
                </Link>
              </div>
            </div>
          </MDBCard>
        </MDBCol>
        <MDBCol md="6" className="md-0 mb-4">
          <MDBCard className="card-image moz-p-home-actions__item moz-p-home-actions__item--3">
            <div className="text-white text-center d-flex align-items-center rgba-black-light py-5 px-4 rounded">
              <div>
                <h6>
                  <Link
                    className="text-success moz-p-home-actions__item-icon"
                    to={ROUTES.COMMON.TRIPS}
                  >
                    <MDBIcon icon="tree" />
                    <strong>{locale.TRAVELS.TRIPS_ONLY}</strong>
                  </Link>
                </h6>
                <h3 className="py-3 font-weight-bold text-shadow heading-tertiary">
                  <Link className="text-white" to={ROUTES.COMMON.TRIPS}>
                    <strong>{locale.TRAVELS.ONE_DAY_TRIPS}</strong>
                  </Link>
                </h3>
                <p className="pb-4 text-shadow paragraph">
                  {locale.TRAVELS.TRIPS_DESCRIPTION}
                </p>
                <Link to={ROUTES.COMMON.TRIPS}>
                  <MDBBtn color="success" rounded size="md">
                    <MDBIcon far icon="clone" className="left" />
                    {locale.COMMON.LOOK}
                  </MDBBtn>
                </Link>
              </div>
            </div>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </section>
  );
};

export default HomeActions;
